import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Spin,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  getAboutLot,
  getCurrentDateUtilYYYY,
  getDateUtilYYYYBydate,
  getOrders,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import LotTable from "../lotTable/LotTable";
import { SearchOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

function LoadingCenterContent(props) {
  return (
    <div className={styles.centerLoadingContent}>
      <Spin tip="Loading" size="large">
        <div className="content" />
      </Spin>
    </div>
  );
}
export default LoadingCenterContent;
